import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.concat";

var _meta, _meta2;

import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../i18n';

var AppMetaTags = function AppMetaTags(_ref) {
  var appName = _ref.appName,
      children = _ref.children,
      description = _ref.description;
  var location = useLocation();

  var _useLanguage = useLanguage(),
      currentLang = _useLanguage.currentLang;

  var url = "".concat(window.location.origin).concat(location.pathname);
  return /*#__PURE__*/React.createElement(Helmet, {
    titleTemplate: "%s \xB7 XYZ ".concat(appName)
  }, /*#__PURE__*/React.createElement("html", {
    lang: currentLang
  }), _meta || (_meta = /*#__PURE__*/React.createElement("meta", {
    property: "twitter:card",
    content: "summary_large_image"
  })), _meta2 || (_meta2 = /*#__PURE__*/React.createElement("meta", {
    property: "og:type",
    content: "website"
  })), /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: url
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:url",
    content: url
  }), /*#__PURE__*/React.createElement("meta", {
    property: "twitter:url",
    content: url
  }), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: description
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:description",
    content: description
  }), /*#__PURE__*/React.createElement("meta", {
    property: "twitter:description",
    content: description
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:image",
    content: "/images/og-".concat(currentLang, ".png")
  }), children);
};

export default AppMetaTags;